/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ReproductionInputs */

const en_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduction`)
};

const es_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducción`)
};

const fr_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduction`)
};

const de_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduktion`)
};

const ja_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レプリカ・複製`)
};

const zh_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复刻/复制品`)
};

const ar_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخة منسوخة`)
};

const id_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduksi`)
};

const it_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riproduzione`)
};

const ru_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Репродукция`)
};

const pt_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprodução`)
};

const ko_val_reproduction = /** @type {(inputs: Val_ReproductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복제품`)
};

/**
* | output |
* | --- |
* | "Reproduction" |
*
* @param {Val_ReproductionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_reproduction = /** @type {((inputs?: Val_ReproductionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ReproductionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_reproduction(inputs)
	if (locale === "es") return es_val_reproduction(inputs)
	if (locale === "fr") return fr_val_reproduction(inputs)
	if (locale === "de") return de_val_reproduction(inputs)
	if (locale === "ja") return ja_val_reproduction(inputs)
	if (locale === "zh") return zh_val_reproduction(inputs)
	if (locale === "ar") return ar_val_reproduction(inputs)
	if (locale === "id") return id_val_reproduction(inputs)
	if (locale === "it") return it_val_reproduction(inputs)
	if (locale === "ru") return ru_val_reproduction(inputs)
	if (locale === "pt") return pt_val_reproduction(inputs)
	return ko_val_reproduction(inputs)
});